import React, { useState } from 'react';
import './KeyModules.css';

function KeyModules() {
  const [boxes, setBoxes] = useState([
    { id: 1, color: 'orange', zIndex: 3, bottom: '0%', width: '90%', height: '70%', courseHeader: 'Front-Office Management', courseDetails: 'This course involves managing the hotel reservations, checkins and checkouts along with handling guest profiles, billing, etc.' },
    { id: 2, color: 'green', zIndex: 2, bottom: '5%', width: '80%', height: '70%', courseHeader:'House Keeping Management', courseDetails: 'Room cleaning procedures, linen and laundry management, inventory control, interior aesthetics and maintenance coordination' },
    { id: 3, color: 'blue', zIndex: 1, bottom: '10%', width: '70%', height: '70%', courseHeader: 'Food & Beverage Services', courseDetails: 'Restaurant operations, table service techniques, bar and beverage service, and banquet operations' },
    { id: 4, color: 'violet', zIndex: -1, bottom: '15%', width: '60%', height: '70%', courseHeader: 'Food Production & Culinary Arts', courseDetails: 'Basic cooking techniques and kitchen safety, international and regional cuisines, menu planning, and kitchen hierarchy and equipment handling.' },
  ]);

  const handleBoxClick = (id) => {
    const clickedBox = boxes.find(box => box.id === id);
    const remainingBoxes = boxes.filter(box => box.id !== id);

    // Move the clicked box to the front and adjust the remaining boxes
    setBoxes([
      { ...clickedBox, zIndex: 3, bottom: '0%', width: '90%' },
      ...remainingBoxes.map((box, index) => ({
        ...box,
        zIndex: 2 - index,
        bottom: `${5 + index * 5}%`,
        width: `${80 - index * 10}%`,
      })),
    ]);
  };

  return (
    <div className='keymodules-outer'>
      <div className="keymodules-inner">
        <div className="keymodules-left d-flex flex-column justify-content-start align-items-start">
          <h4 className="secondary-header">KEY MODULES</h4>
          <p className="letter-text">At LIMS we cover all the modules there are in the hotel management. Starting from front-office operations to International Hospitality Standard we offer you everything. <br /> By the end of your diploma course at Hotel Management, you will learn soft skills, communication skills, and all other advanced skill that will be required in this industry.</p>
        </div>
        <div className="keymodules-right">
          {boxes.map(box => (
            <div
              key={box.id}
              className="keymodules-box"
              style={{
                backgroundColor: box.color,
                zIndex: box.zIndex,
                bottom: box.bottom,
                width: box.width,
                height: box.height
              }}
              onClick={() => handleBoxClick(box.id)}
            >
              <div className="coursediv w-100 h-100 d-flex justify-content-center align-items-center flex-column" >
                <p className='paragraph-text d-flex justify-content-center align-items-center w-100 h-auto'>{box.courseHeader}</p>
                <p className='p-4 letter-text text-center d-flex justify-content-center align-items-center w-75 h-auto'>{box.courseDetails}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default KeyModules;
